import React, { useState, useEffect } from "react";
import TimeStamp from "react-timestamp";

import axios from "axios";
import { server } from "../../../utills/utils";

import styled from "styled-components";

import Order from "./Order/PendingOrder";
import Modal from "../../Modals/SignModal";
import OrderedItem from "./Order/OrderedItem";
import Spinner from "../../Modals/SpinnerModal";

import EmptyImg from "../../../assets/Orders.png";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const ViewOrder = styled.div`
  width: 100%;
  height: 83vh;
  padding: 2%;
`;
const OrderHeader = styled.div`
  width: 100%;
  height: 8%;
`;
const OrderBody = styled.div`
  width: 100%;
  height: 75%;
  overflow-y: scroll;
`;
const OrderFooter = styled.div`
  width: 100%;
  height: 15%;
  border-top: 1px solid #eee;
`;
const HeaderTitle = styled.h3`
  float: left;
  margin: 0;
  padding: 5px 0;
  font-weight: 500;
`;
const OrderTime = styled.p`
  float: right;
  margin: 0;
  padding: 8px 0;
  color: gray;
`;
const TotalItem = styled.h3`
  float: left;
  margin: 0;
  padding: 5px 0;
  font-weight: 400;
  font-size: 1em;
  width: 50%;
  text-align: left;
`;
const TotalPrice = styled.h3`
  float: right;
  margin: 0;
  padding: 5px 0;
  font-weight: 500;
  font-size: 1em;
  width: 50%;
  text-align: right;
`;
const Button1 = styled.button`
  padding: 10px 0;
  font-size: 1em;
  background: #276fb7;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  width: 47.5%;
  margin: 0 0 0 3%;
`;
const Button2 = styled.button`
  padding: 10px 0;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
  width: 48%;
`;

function PendingOrders() {
  const [view, setView] = useState(false);
  const [order, setOrder] = useState({});
  const [orderView, setOrderView] = useState(false);
  const [orders, setOrders] = useState([]);
  const [complete, setComplete] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const orderViewHandler = async (id) => {
    setSpinner(true);
    // setView(true);
    const order = await axios.post(server, {
      query: `
                 query{
                     order(orderId:"${id}"){
                        _id
                        shopId
                        userId
                        createdAt
                        orderNo
                        orderedProducts{
                            itemId
                            price
                            quantity
                            image
                            name
                        }
                     }
                 }
              `,
    });
    setOrder(order.data.data.order);
    setOrderView(true);
    setSpinner(false);
    setView(true);
    console.log(order);
  };

  const orderViewCloseHandler = () => {
    setView(false);
  };

  const fectchOrders = async () => {
    try {
      const orders = await axios.post(server, {
        query: `
                    query{
                        shopPendingOrders(token:"${localStorage.shopToken}"){
                            _id
                            shopId
                            userId
                            total
                            orderNo
                            orderedProducts{
                                itemId
                                price
                                quantity
                                image
                                name
                            }
                        }
                    }
                  `,
      });
      console.log(orders);
      setOrders(orders.data.data.shopPendingOrders);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };

  const confirmOrderHandler = async () => {
    try {
      setView(false);
      setSpinner(true);
      const confirmOrder = await axios.post(server, {
        query: `
                    mutation{
                        confirmOrder(orderId: "${order._id}"){
                            _id
                            shopId
                            userId
                            total
                            orderNo
                            orderedProducts{
                                itemId
                                price
                                quantity
                                image
                                name
                            }
                        }
                    }
                  `,
      });
      setOrders(confirmOrder.data.data.confirmOrder);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };
  const cancelOrderHandler = async () => {
    try {
      setView(false);
      setSpinner(true);
      const cancelOrder = await axios.post(server, {
        query: `
                    mutation{
                        cancelOrder(orderId: "${order._id}"){
                            _id
                            shopId
                            userId
                            total
                            orderNo
                            orderedProducts{
                                itemId
                                price
                                quantity
                                image
                                name
                            }
                        }
                    }
                  `,
      });
      setOrders(cancelOrder.data.data.cancelOrder);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };
  let total = 0;
  useEffect(() => {
    fectchOrders();
  }, []);
  return (
    <Container>
      <Spinner show={spinner} />
      <Modal show={view} closeModal={orderViewCloseHandler}>
        {orderView ? (
          <ViewOrder>
            <OrderHeader>
              <HeaderTitle>Order no : {order.orderNo}</HeaderTitle>
              <OrderTime>
                <TimeStamp time={order.createdAt} />
              </OrderTime>
            </OrderHeader>
            <OrderBody>
              {order.orderedProducts.map((product, id) => {
                total += product.price * product.quantity;
                return <OrderedItem key={id} cartItem={product} />;
              })}
            </OrderBody>
            <OrderFooter>
              <div style={{ width: "100%", height: "40px" }}>
                <TotalItem>
                  {order.orderedProducts.length} items ordered
                </TotalItem>
                <TotalPrice>Total Amount : {total} TK</TotalPrice>
              </div>
              <div style={{ width: "100%" }}>
                <Button2 onClick={cancelOrderHandler}>Cancel</Button2>

                <Button1 onClick={confirmOrderHandler}>Confrim</Button1>
              </div>
            </OrderFooter>
          </ViewOrder>
        ) : null}
      </Modal>
      {complete ? (
        orders.length > 0 ? (
          orders.map((order) => {
            return (
              <Order
                key={order._id}
                order={order}
                orderViewHandler={orderViewHandler}
              />
            );
          })
        ) : (
          <img
            style={{ width: "100%", textAlign: "center", height: "80%" }}
            src={EmptyImg}
            alt="image"
          />
        )
      ) : (
        <p>Loading...</p>
      )}
    </Container>
  );
}

export default PendingOrders;
